import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { UnauthorizedComponent } from './components/dialogs/unauthorized/unauthorized.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoaderComponent } from './components/loaders/loader/loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { ButtonDividerComponent } from './components/controls/button-divider/button-divider.component';
import { SearchComponent } from './components/controls/search/search.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { CoreModule } from '../core/core.module';
import { RouteService } from './services/route.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MustTrimValidatorDirective } from './validators/must-trim.directive';
import { RequiredFieldValidatorDirective } from './validators/required-field-validator.directive';
import { OverlayLoaderComponent } from './components/loaders/overlay-loader/overlay-loader.component';
import { AutocompleteComponent } from './components/controls/autocomplete/autocomplete.component';
import { FilterPipe } from './directives/filter.pipe';
import { ToastComponent } from './components/dialogs/toast/toast.component';
import { MultiSelectGridComponent } from './components/controls/multi-select-grid/multi-select-grid.component';
import { CommonSearchComponent } from './components/controls/common-search/common-search.component';
import { ToastMessageComponent } from './components/dialogs/toast-message/toast-message.component';

@NgModule({
  declarations: [
    UnauthorizedComponent,
    LoaderComponent,
    ButtonDividerComponent,
    SearchComponent,
    ToastComponent,
    OverlayLoaderComponent,
    MustTrimValidatorDirective,
    RequiredFieldValidatorDirective,
    AutocompleteComponent,
    FilterPipe,
    MultiSelectGridComponent,
    CommonSearchComponent,
    ToastMessageComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatIconModule
  ],
  exports: [
    UnauthorizedComponent,
    LoaderComponent,
    ButtonDividerComponent,
    SearchComponent,
    ToastComponent,
    OverlayLoaderComponent,
    MustTrimValidatorDirective,
    RequiredFieldValidatorDirective,
    AutocompleteComponent,
    FilterPipe,
    MultiSelectGridComponent,
    CommonSearchComponent,
    ClipboardModule,
    A11yModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,
    MatTabsModule,
    RouterModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    ToastMessageComponent
  ],
  providers: [
    RouteService
  ]
})
export class SharedModule { }


